<template>
  <div class="onls-file-input">
    <div v-if="label" class="field-label">{{ label }}</div>

    <div class="d-flex ai-center">
      <div class="onls-file-input__container">
        <input type="file" :accept="getAcceptedFiles" @change="onInput">

        <div class="onls-file-input__button">
          <div class="color-primary">{{ !value ? buttonText : value.name || uploadedText }}</div>

          <upload-icon v-if="!value"/>
          <delete-icon class="onls-file-input__button--delete" @click="onDelete" v-else/>
        </div>
      </div>

      <div v-if="description" class="onls-file-input__description">{{ description }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import UploadIcon from "./icons/upload.vue";
import DeleteIcon from "./icons/delete.vue";
import {computed} from "vue";
import {fileAcceptInputMapper} from "../shared/file-type-format-mapper";

const props = defineProps({
  label: { type: String },
  description: { type: String },
  buttonText: { type: String },
  uploadedText: { type: String },
  value: { type: Object },
  accept: { type: Array, default: () => ([]) }, // IMAGES, VIDEO, DOCUMENT, EXCEL
});

const emits = defineEmits(['update:value', 'delete']);

const getAcceptedFiles = computed(() => props.accept!.map(type => fileAcceptInputMapper.get(type)).flat().join(','));

const onInput = (e: any) => {
  emits('update:value', e.target.files[0]);
};

const onDelete = () => {
  emits('delete');
};

</script>

<style lang="scss">
.onls-file-input {
  width: 100%;

  &__container {
    position: relative;

    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
  }

  &__button {
    display: flex;
    align-items: center;
    border: 2px solid var(--primary-text);
    background: var(--secondary-background);
    padding: 16px 25px;
    border-radius: 5px;
    cursor: pointer;

    div {
      font-size: 15px;
      margin-right: 35px;
    }

    &--delete {
      position: absolute;
      right: 25px;
    }
  }

  &__description {
    color: var(--secondary-text);
    width: 300px;
    margin-left: 25px;
  }

  @media screen and (max-width: 768px) {
    &__description {
      display: none;
    }

    &__button {
      padding: 13px 20px;

      div {
        font-size: 12px;
        margin-right: 30px;
      }

      &--delete {
        position: absolute;
        right: 20px;
      }
    }
  }
}
</style>
